module.exports = __webpack_public_path__ + "img/titleTwo2.ac67ecd8.png";